import Link from "next/link";
import { Children } from "react";

import { Button, Text } from "@aprosoja/ui";
import { formatPhone } from "@aprosoja/utils";

import ContentWrapper from "../components/content-wrapper";
import { useSignUpContext } from "@/app/screens/sign-up/context/sign-up.context";

const AfterPayment = () => {
  const { signUpReducer, setSignUpReducer } = useSignUpContext();
  const MEMBERS_URL =
    process.env.MEMBERS_URL ?? process.env.NEXT_PUBLIC_MEMBERS_URL;

  const supportEmails = ["aprosojars@aprosojars.com.br"];
  const supportPhone = "54992391161";

  return (
    <ContentWrapper
      title={
        signUpReducer?.paymentSucceeded
          ? "Sua conta foi criada!"
          : "Tivemos um problema com seu pagamento."
      }
      description={
        signUpReducer?.paymentSucceeded
          ? "Você pode acessar sua conta clicando no botão abaixo:"
          : "Não conseguimos enviar seu pagamento para análise. Por favor, tente novamente."
      }
      hasSummary
      isAfterPayment
      paymentSucceeded={signUpReducer?.paymentSucceeded}
    >
      {!signUpReducer?.paymentSucceeded ? (
        <div className="flex w-full justify-center items-center gap-size-x2">
          {signUpReducer?.pixOrBankSlipInfo?.id && (
            <Button
              className="rounded-border-radius-small"
              variant="outlined"
              onClick={() =>
                setSignUpReducer({ type: "signUpStep", signUpStepPayload: 3 })
              }
            >
              Tentar novamente
            </Button>
          )}
          <Button
            className="rounded-border-radius-small"
            variant="outlined"
            onClick={() =>
              setSignUpReducer({ type: "signUpStep", signUpStepPayload: 2 })
            }
          >
            Escolher outro método de pagamento
          </Button>
        </div>
      ) : (
        <Link
          href={MEMBERS_URL ?? ""}
          target="_blank"
          className="justify-self-end"
        >
          <Button
            variant="outlined"
            endIcon="login"
            className="border-th-color-neutral-900 text-th-color-neutral-900 rounded-border-radius-small"
            size="large"
          >
            Entrar
          </Button>
        </Link>
      )}
      <div className="flex flex-col w-full gap-size-x6 pt-size-x10">
        <Text type="headingM">
          Se tiver dúvidas, entre em contato com nosso suporte.
        </Text>
        <div className="flex flex-col w-full gap-size-x4">
          <Text type="headingS">E-mail</Text>
          <Text type="paragraphL">
            Entre em contato por e-mail ou telefone.
          </Text>
          {Children.toArray(
            supportEmails.map((email) => (
              <Link href={`mailto:${email}`}>
                <Text type="headingS" className="underline">
                  {email}
                </Text>
              </Link>
            ))
          )}
        </div>
        <div className="flex flex-col w-full gap-size-x4">
          <Text type="headingS">Telefone e Whatsapp</Text>
          <Link href={`tel:+55${supportPhone}`}>
            <Text type="paragraphL" className="underline">
              {formatPhone(supportPhone)}
            </Text>
          </Link>
        </div>
      </div>
    </ContentWrapper>
  );
};

export default AfterPayment;
